import { render, staticRenderFns } from "./capa_detail.vue?vue&type=template&id=3f724e99&scoped=true&"
import script from "./capa_detail.vue?vue&type=script&lang=js&"
export * from "./capa_detail.vue?vue&type=script&lang=js&"
import style0 from "./capa_detail.vue?vue&type=style&index=0&id=3f724e99&lang=less&scoped=true&"
import style1 from "./capa_detail.vue?vue&type=style&index=1&id=3f724e99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f724e99",
  null
  
)

export default component.exports